import React, { useState } from 'react';
import { Button, Modal, Typography } from 'antd';
import { observer } from 'mobx-react';
import useStore from '../../../../store';
import Message from '../../../../config/Message';
import { Notification } from '../../../../config/Global';
const { Title } = Typography;

const DeleteComponent = observer((props) => {
	const { visible, onClose } = props;
	const [saving, setSaving] = useState();
	const { MERCHANT } = useStore();

	const deleteMerchant = () => {
		setSaving(true);
		MERCHANT.deleteMerchant({
			id: visible.id.toString(),
			versionNo: visible.versionNo,
		})
			.then((msg) => {
				Notification.success({
					message: Message().CRUD.DELETE('Merchant'),
				});
				onClose();
			})
			.catch((e) => {
				Notification.error({
					message: 'Something Wrong',
				});
			})
			.finally(() => setSaving(false));
	};

	return (
		<Modal
			title="Delete Merchant"
			onCancel={onClose}
			open={visible}
			destroyOnClose
			width={'450px'}
			footer={
				<div>
					<Button
						type="primary"
						key={1}
						loading={saving}
						onClick={deleteMerchant}
					>
						Delete
					</Button>
					<Button key={2} onClick={onClose}>
						Cancel
					</Button>
				</div>
			}
		>
			<Title level={5}>
				Are you sure you want to delete
				<b>{' ' + visible?.merchantName}</b> merchant?
			</Title>
		</Modal>
	);
});

export default DeleteComponent;
